import { Link } from "react-router-dom";
import { format } from "date-fns";
import { es } from "date-fns/locale";
import { CalendarIcon, UserRound } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Checkbox } from "@/components/ui/checkbox";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

export const LoginHint = () => (
  <div className="flex flex-wrap items-center justify-between gap-3 bg-slate-50 border border-slate-200 rounded-xl px-4 py-3 text-sm" data-testid="booking-login-hint">
    <span className="flex items-center gap-2 text-slate-600">
      <UserRound className="h-4 w-4 text-cyan-600" /> ¿Cliente habitual? Inicia sesión y rellenamos tus datos.
    </span>
    <Link to="/cuenta?next=/reservar" data-testid="booking-login-link" className="font-medium text-cyan-700 hover:text-cyan-800 underline underline-offset-2">
      Iniciar sesión
    </Link>
  </div>
);

export const PickupDatePicker = ({ pickupDate, setPickupDate }) => {
  const minDate = new Date(Date.now() + 86400000).toISOString().split("T")[0];
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button type="button" variant="outline" data-testid="booking-date-input" className="w-full justify-start font-normal">
          <CalendarIcon className="h-4 w-4 mr-2 text-slate-500" />
          {pickupDate ? format(pickupDate, "PPP", { locale: es }) : "Elige una fecha"}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar mode="single" selected={pickupDate} onSelect={setPickupDate}
          locale={es} disabled={(d) => d < new Date(minDate)} initialFocus />
      </PopoverContent>
    </Popover>
  );
};

export const CustomerFields = ({ details, field, pickupDate, setPickupDate }) => (
  <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
    <div className="space-y-2">
      <Label htmlFor="b-name">Nombre completo</Label>
      <Input id="b-name" data-testid="booking-name-input" required minLength={2}
        value={details.customer_name} onChange={field("customer_name")} />
    </div>
    <div className="space-y-2">
      <Label htmlFor="b-email">Correo electrónico</Label>
      <Input id="b-email" data-testid="booking-email-input" type="email" required
        value={details.customer_email} onChange={field("customer_email")} />
    </div>
    <div className="space-y-2">
      <Label htmlFor="b-phone">Teléfono</Label>
      <Input id="b-phone" data-testid="booking-phone-input" required minLength={6}
        value={details.customer_phone} onChange={field("customer_phone")} />
    </div>
    <div className="space-y-2">
      <Label>Fecha de recogida</Label>
      <PickupDatePicker pickupDate={pickupDate} setPickupDate={setPickupDate} />
    </div>
  </div>
);

export const TermsCheckbox = ({ checked, onChange }) => (
  <label className="flex items-start gap-3 text-sm text-slate-600 cursor-pointer" htmlFor="b-terms">
    <Checkbox id="b-terms" data-testid="booking-terms-checkbox" checked={checked}
      onCheckedChange={(v) => onChange(v === true)} className="mt-0.5" />
    <span>
      He leído y acepto las{" "}
      <Link to="/condiciones" target="_blank" className="text-cyan-700 underline underline-offset-2">Condiciones del servicio</Link>{" "}
      y la{" "}
      <Link to="/privacidad" target="_blank" className="text-cyan-700 underline underline-offset-2">Política de privacidad</Link>.
    </span>
  </label>
);
